import React, { Fragment, useEffect, useState } from 'react';
import InputField from './InputField';
import { translate } from '../Services/translation';
import { useDispatch, useSelector } from 'react-redux';
import { emailChangeSchema } from './MyAcount.ValidationSchema';
import { clearEmailChangeError, saveEmailChange, submitEmailChangeError } from '../Actions/MyAccount.action';
import { addFlashMessage } from '../Actions/FlashMessages.action';

 const validateEmail = async (data) => {
    return await emailChangeSchema.validate(data, { abortEarly: false });
}

const MyAccountChangeEmail = () => {
    const dispatch = useDispatch();
    const { payload, errors } = useSelector(state => state.myAccountChangeEmail);
    const { currentEmail, newEmail } = payload;

    const [isEditing, setIsEditing] = useState(false);
    const [isSaving, setIsSaving] = useState(false)
    const [formData, setFormData] = useState({
        newEmail,
        password: '',
    })

    const resetFormPassword = () => {
        setFormData((currentForm) => ({
            ...currentForm,
            password: ''
        }))
    }

    const handleFieldChange = (name, value) => {
        setFormData((currentForm) => ({
            ...currentForm,
            [name]: value,
        }));
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        setIsSaving(true);
        dispatch(clearEmailChangeError());

        try {
            await validateEmail(formData);
            await dispatch(saveEmailChange(formData))
            dispatch(addFlashMessage({ 
                messageText: translate('js.myaccount.settings.message.emailchanged'),
                messageType: "Green", 
                dismissible: true, 
                timeToLive: 10 }))
            setIsEditing(false);
        } catch (ex) {
            dispatch(submitEmailChangeError(ex));
        }
        finally {
            setIsSaving(false);
            resetFormPassword();
        }
    }

    const handleCancel = (event) => {
        event.preventDefault();
        dispatch(clearEmailChangeError());
        setIsEditing(false);
        setFormData({
            newEmail: payload.currentEmail,
            password: ''
        })
    }

    return (
        <Fragment>
            <div className="my-account-settings__component email">
                <h2>{translate('js.myaccount.settings.heading.email')}</h2>
                {!isEditing ? 
                    (<Fragment>
                        <p>{currentEmail}</p>
                        <button onClick={() => setIsEditing(true)} className="button">{translate('js.myaccount.settings.button.changeemail')}</button>
                    </Fragment>) 
                :
                    (<form onSubmit={handleSubmit}>
                        <InputField
                            id='newEmail'
                            name='newEmail'
                            type='email'
                            value={formData.newEmail}
                            required={true}
                            label={translate('js.myaccount.settings.label.email')}
                            onChange={(value) => handleFieldChange('newEmail', value)}
                            errors={errors}
                            containerCssClass='half-row'
                        />
                        <InputField
                            id='password'
                            name='password'
                            type='password'
                            value={formData.password}
                            required={true}
                            label={translate('js.myaccount.settings.label.password')}
                            onChange={(value) => handleFieldChange('password', value)}
                            errors={errors}
                            containerCssClass='half-row'
                        />
                        <div className="email__buttons">
                            <button type="submit" className={`button button__primary ${isSaving && 'loading'}`} disabled={isSaving}>
                                <span>{translate('js.myaccount.settings.button.saveemail')}</span>
                                <span className="spinner spinner--light spinner--small"></span>
                            </button> 
                            <button onClick={handleCancel} className="button button__outline" disabled={isSaving}>{translate("js.myaccount.settings.button.cancel")}</button>
                        </div>
                    </form>)
                }
            </div>
        </Fragment>
    )
}

export default MyAccountChangeEmail;